import {
    lightThemeOptions,
    PiLetterCircleThemeOptions,
    PiTwoPaneLayoutThemeOptions,
} from '@sensei/pi-component';
import { ThemeOptions } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { MuiCssBaseline } from './components/css-baseline.theme';
import { MuiButton } from './components/button.theme';
import { MuiFab } from './components/fab.theme';
import { MuiSnackbarContent } from './components/snackbar-content.theme';
import { MuiLink } from './components/link.theme';
import { MuiTab } from './components/tab.theme';

declare module '@mui/material/styles' {
    interface Theme {
        PiComponents: {
            PiTwoPaneLayout: PiTwoPaneLayoutThemeOptions;
            PiLetterCircle: PiLetterCircleThemeOptions;
        };
    }

    // allow configuration using `createTheme`
    interface ThemeOptions {
        PiComponents?: {
            PiTwoPaneLayout?: PiTwoPaneLayoutThemeOptions;
            PiLetterCircle?: PiLetterCircleThemeOptions;
        };
    }
}
export const lightTheme = createTheme(overrideTheme(lightThemeOptions));

export default lightTheme;

function overrideTheme(themeOptions: ThemeOptions): ThemeOptions {
    return {
        ...themeOptions,
        // Overwrite the material UI 5 breakpoints
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
        components: {
            ...themeOptions.components,
            MuiCssBaseline: MuiCssBaseline(themeOptions),
            MuiButton: MuiButton(themeOptions),
            MuiFab: MuiFab(themeOptions),
            MuiSnackbarContent: MuiSnackbarContent(themeOptions),
            MuiLink: MuiLink(themeOptions),
            MuiTab: MuiTab(themeOptions),
        },
    };
}
